import { Component, OnInit, input } from '@angular/core';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: false
})
export class BadgeComponent implements OnInit {
    /**
     * Text to display in badge
     */
    readonly text = input<string>(undefined);

    readonly circle = input(false);

    readonly badgeStyleClass = input('');

    readonly color = input('');

    /**
     * Size of badge. Can be small (default), medium, large or fluid (adapts to the content)
     */
    readonly size = input('default');

    badgeContainerClasses: string;
    badgeStyleClasses: string;

    ngOnInit() {
      this.badgeContainerClasses = `is-${this.size()} ${this.circle() ? 'circle' : ''} is-${this.color()}`;
      this.badgeStyleClasses = `badge ${this.badgeStyleClass()}`;
    }
}

/**
 * Used in Settings Lux
 * Used in Settings Legrand
 */
